<template>
    <div class="antialiased">
        <Sidebar />
        <div class="page">
            <Header hint="Ketik no. invoice"  @change="_search"/>
            <div class="content">
                <div class="container">
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">Retur Penjualan Group</h2>
                            </div>
                            <div class="col-auto">
                                <div class="row">
                                    <div class="col-auto px-0">
                                        <div class="input-icon">
                                        <span class="input-icon-addon">
                                            <i class="fe fe-align-left"></i>
                                        </span>
                                        <select
                                            class="form-control"
                                            :disabled="loading"
                                            @change="_perPageChange"
                                        >
                                            <option
                                                :key="i"
                                                :value="num"
                                                v-for="(num, i) in [10, 50, 100, 999]"
                                                v-html="num == 999 ? 'Semua' : num"
                                            />
                                        </select>
                                        </div>
                                    </div>

                                    <div class="col-auto">
                                        <button
                                            class="btn btn-white"
                                            v-html="ic('filter')"
                                            @click="_filter"
                                        >
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="mb-4">
                        <b-nav tabs>
                            <b-nav-item :active="$route.name == 'ReturPenjualanUngroup'">
                                <router-link :to="{name:'ReturPenjualanUngroup'}">
                                Retur Penjualan
                                </router-link>
                            </b-nav-item>
                            <b-nav-item :active="$route.name == 'ReturPenjualanGroup'">
                                <router-link :to="{name:'ReturPenjualanGroup'}">
                                Print Group
                                </router-link>
                            </b-nav-item>
                        </b-nav>
                    </div>

                    <router-view ref="componentRef"></router-view>

                </div>
            </div>
        </div>
        
        
    </div>    
</template>

<script>
    import helper from "@/assets/js/helper.js";

    export default {
        name: "IndexReturPenjualanGroup",
        data(){
            return {
                loading: false,
            }
        },
        mixins: [helper],
        methods: {
            _filter(){
                this.$refs.componentRef._filter();
            },
            _perPageChange(event){
                this.$refs.componentRef._perPageChange(event.target.value)
            },
            _search(keyword) {
                this.$refs.componentRef._search(keyword)
            },


        }

    }
</script>
